import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import PageTopTitle from "../../components/shared/PageTopTitle";
import AdminUetdsBildirimContainer from "../../components/adminContainers/AdminUetdsBildirimContainer";
import { getAllUetdsNotification } from "../../features/admin4/admin4Slice";
import InputSelect from "../../components/shared/input/new/InputSelect";
import InputText from "../../components/shared/input/new/InputText";
import InputNumberNew from "../../components/shared/input/new/InputNumberNew";
import Btn from "../../components/shared/button/Btn";
import Pagination from "../../components/shared/Pagination";

const Container = styled.div`
  width: 100%;
  height: 100%;
  .content{ 
    margin: 30px;
    display: flex;
    flex-direction: column;
    gap: 20px;
    .filter-container{
      display: flex;
      align-items: center;
      gap: 10px;
    }
    .titles {
        width: 100%;
        display: grid;
        grid-template-columns:repeat(11, 1fr);
        gap: 15px;
        padding-inline: 10px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-lg);
        text-align: center;
        color: ${({ theme }) => theme.mainTextColor};
      }
  }
`

const titles = ["Bildirim Tarihi", "Ad Soyad", "Telefon", "Kilometre", "İl/İlçe", "Bildirim Yeri", "İstasyon Adı", "Açıklama", "Sürücü Açıklama", "Durum", "İşlem"];

const statusData = [
  {
    id: 0,
    text: "İşlem Yapılmadı",
  },
  {
    id: 1,
    text: "Evet",
  },
  {
    id: 2,
    text: "Hayır",
  },
]

const calledData = [
  {
    id: 1,
    text: "Arandı",
    bool: true
  },
  {
    id: 2,
    text: "Aranmadı",
    bool: false
  }
]

const typeData = [
  {
    id: 1,
    text: "1. Konum",
  },
  {
    id: 2,
    text: "2. Konum",
  },
  {
    id: 3,
    text: "3. Konum",
  },
  {
    id: 4,
    text: "Son Konum",
  }
]

const UetdsBildirimKontrol = () => {
  const dispatch = useDispatch();
  const { uetdsNotificationList, uetdsNotificationCount } = useSelector((state) => state.admin4);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 30;
  const totalPages = Math.ceil(uetdsNotificationCount / itemsPerPage);

  const [notificationStatus, setNotificationStatus] = useState(null);
  const [isDriverCalled, setIsDriverCalled] = useState(null);
  const [type, setType] = useState(null);
  const [filterData, setFilterData] = useState({
    km: "",
    driverName: "",
    phoneNumber: "",
  })
   
  useEffect(() => {
    dispatch(getAllUetdsNotification({page: currentPage, type: type?.id, driverName: filterData.driverName, notificationStatus: notificationStatus?.id, isDriverCalled: isDriverCalled?.bool, phoneNumber: filterData.phoneNumber}))
  }, [currentPage, filterData, notificationStatus, isDriverCalled, type])

  const handleChange = (e) => {
    setFilterData({...filterData, [e.target.name]: e.target.value})
  }

  const handleClear = () => {
    setFilterData({
      km: "",
      driverName: "",
      phoneNumber: "",
    })
    setNotificationStatus(null);
    setIsDriverCalled(null);
  }

  return (
    <Container>
      <div className="wrapper">
        <PageTopTitle title={"UETDS Bildirimleri"} position="sticky" />
        <div className="content">
          <div className="filter-container">
            <InputText data={filterData.driverName} setData={(e) => handleChange(e)} labelText="Sürücü Adı" name={"driverName"} inputWidth={"180px"} />
            <InputText data={filterData.phoneNumber} setData={(e) => handleChange(e)} labelText="Sürücü Telefon" name={"phoneNumber"} inputWidth={"180px"} />
            <InputSelect data={notificationStatus?.text} setData={setNotificationStatus} initialOptions={statusData} labelText={"Bildirim Durumu"} inputWidth={"180px"} name={"notificationStatus"} />
            <InputSelect data={type?.text} setData={setType} initialOptions={typeData} labelText={"Konum"} inputWidth={"180px"} name={"type"} />
            <InputSelect data={isDriverCalled?.text} setData={setIsDriverCalled} initialOptions={calledData} labelText={"Aranma Durumu"} inputWidth={"180px"} name={"isDriverCalled"} />
            <Btn color="#E85446" bgColor="transparent" handleClick={handleClear} padding="0 10px">Temizle</Btn>
          </div>
          <div className="titles">
            {titles.map((item) => (
              <p>{item}</p>
            ))}
          </div>

          {uetdsNotificationList.map((item) => (
            <AdminUetdsBildirimContainer data={item} />
          ))}

        </div>

        {(uetdsNotificationList || uetdsNotificationList?.length > 0) && (
          <Pagination
            totalPages={totalPages}
            handleClick={setCurrentPage}
            currentPage={currentPage}
          />
        )}
      </div>
    </Container>
  );
};

export default UetdsBildirimKontrol;
